<template>
  <v-app id="wrap-project">

    <loading :active.sync="busy"/>

    <div v-if="!busy" id="content-wrap">

      <!-- Header -->
      <header id="header-project">

        <div id="project-title">
          <div id="btn-menu-wrap">
            <div id="btn-menu">
              <v-btn icon dark @click="menu_bar_visible=true">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </div>
          </div>
          <router-link tag="div"
            class="bt-menu"
            :to="{name:'lab'}">
            <span class="link-element">LAB</span>
            <span>&nbsp;/&nbsp;</span> 
          </router-link>

          <div v-if="mode==11">
            <v-icon>mdi-account-multiple</v-icon>
          </div>
          
          <div id="bt-subtitle">{{ project_info.title }}</div>
          <v-chip v-if="is_inactive" class="ma-2" x-small
            @click="activate_dialog=true">
            {{ $t('project.read_only') }}
          </v-chip>
          
          <div id="btn-more">
            <v-menu offset-y>
              <template v-slot:activator="{ on: { click } }">
                <div v-on:click.stop.prevent="click">
                  <v-btn small icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list dense>
                <v-list-item @click.stop="updateProject()">
                  <span>{{ $t('project.update_project') }}</span>
                </v-list-item>
                <v-list-item :inactive="expired" @click.stop="shareProject()">
                  <span>프로젝트 공개</span>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div id="btn-account">
          <div id="comment-btn" v-if="mode==11||!!comments.length">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" v-if="!comments_on"
                  @click="$router.push({ name: 'project', query: { comments: 'true' } })">
                  <v-icon>mdi-message-reply-text</v-icon>
                </v-btn>
                <v-btn icon v-on="on" v-else
                  @click="$router.push({ name: 'project' })">
                  <v-icon color="primary">mdi-message-reply-text</v-icon>
                </v-btn>
              </template>
              <span v-if="comments_on">코멘트 끄기</span>
              <span v-else>코멘트 켜기</span>
            </v-tooltip>
          </div>
          <account-menu></account-menu>
        </div>
        
      </header>

      <!-- content -->
      <div id="content">

        <!-- Fab new doc -->
        <div id="fab-new-doc" v-if="!!proj_keys.length">
          <div v-if="!doc">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="showAddDocuments()" depressed v-on="on"
                  fab small :color="coloring('lotus', 10, 1)">
                  <v-icon :color="coloring('lotus', 0.2, 1)">mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>프로젝트에 도큐먼트 추가하기</span>
            </v-tooltip>
          </div>
          <div v-else-if="!proj_keys.includes(doc)&&drawer_open==1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="addDocumentToProject()" depressed v-on="on"
                  fab small :color="coloring('pink', 10, 1)">
                  <v-icon :color="coloring('pink', 0.2, 1)">mdi-playlist-plus</v-icon>
                </v-btn>
              </template>
              <span>프로젝트에 이 도큐먼트 추가하기</span>
            </v-tooltip>
          </div>
          <div v-else-if="drawer_open==1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="removeDocumentFromProject()" depressed v-on="on"
                  fab small :color="coloring('pink', 10, 1)">
                  <v-icon :color="coloring('pink', 0.2, 1)">mdi-playlist-minus</v-icon>
                </v-btn>
              </template>
              <span>프로젝트에서 이 도큐먼트 제거하기</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Fab drawer -->
        <div id="fab-drawer" v-if="!!proj_keys.length">
          <v-btn :disabled="pending_fab" v-if="drawer_open==1" 
            @click="drawer_open=0"
            fab small class="white--text" color="#ff5193">
            <v-icon >mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn :disabled="pending_fab" v-if="drawer_open==0" 
            @click="drawer_open=1"
            fab small class="white--text" color="#ff5193">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <!-- Left pane -->
        <div id="content-left" v-show="!fixed_pane">

          <div v-show="view_tree">
            <v-tooltip right >
              <template v-slot:activator="{ on }">
                <div class="tree-tool" v-on="on"
                  @click="reloadTree()">
                  <v-icon small>mdi-reload</v-icon>
                </div>
              </template>
              <span>{{ $t('project.reload') }}</span>
            </v-tooltip>
          </div>

          <!-- Tree -->
          <section id="tree" v-show="view_tree">
            <app-tree ref="tree"></app-tree>
          </section>

          <!-- Project Note -->
          <section id="note" v-show="!view_tree"
            :style="{ 'width': left_margin_width + 'px'}">
            <app-project-note/>
          </section>
        </div>

        <!-- Fab for note -->
        <div id="fab-note" v-if="!fixed_pane">
          <v-btn @click="view_tree=!view_tree"
            fab dark color="#ff5193">
            <v-icon v-if="view_tree">mdi-file-document-edit</v-icon>
            <v-icon v-else>mdi-vector-polyline</v-icon>
          </v-btn>
        </div>

        <multipane id="pane-wrap">
          <div id="pane-left" v-resize="onResize"
            :class="{ 'pane-left-fixed': !drawer_open, 'pane-left-removed': fixed_pane }"></div>
          <multipane-resizer v-show="!!drawer_open&&draggable"></multipane-resizer>
          <div v-show="!!drawer_open" id="pane-right" 
            :class="{ 'pane-right-fixed': fixed_pane, 'pane-right-removed': !drawer_open }">
            <drawer :comments_on="comments_on"></drawer>
          </div>
        </multipane>

      </div>

    </div>

    <!-- Modals -->
    <menu-bar
      :dialog.sync="menu_bar_visible">
    </menu-bar>

    <modal-update-project
      :dialog.sync="update_project_visible">
    </modal-update-project>
    
    <modal-share-project
      :dialog.sync="share_project_visible">
    </modal-share-project>

    <modal-add-documents
      :dialog.sync="add_documents_visible"
      @close="hideAddDocumentsModal()">
    </modal-add-documents>

    <modal-import-files
      :dialog.sync="import_files_visible"
      @close="hideImportFilesModal()">
    </modal-import-files>

    <modal-expired></modal-expired>

    <!-- activate dialog -->
    <template>
      <v-dialog v-model="activate_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span v-if="activate_possible">프로젝트를 활성화하시겠습니까?</span>
            <span v-else>BT 프리미엄 회원이 되어주세요!</span>
            <v-btn icon @click.stop="activate_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div class="word-break">일반 회원은 3개의 프로젝트를 사용하실 수 있습니다.</div>
            <div class="word-break" v-if="activate_possible">활성화한 프로젝트는 다시 읽기 전용으로 바꿀 수 없습니다.</div>
            <div class="word-break" v-else>프리미엄을 구독하시면 더 많은 프로젝트를 만들 수 있습니다.</div>
          </v-card-text>

          <v-card-actions>
            <v-btn v-if="activate_possible" class="primary" @click="activateProject" depressed block>
              프로젝트 활성화하기
            </v-btn>
            <v-btn v-else class="primary" @click="toSignup" depressed block>
              프리미엄 구독하기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- No share dialog -->
    <template>
      <v-dialog v-model="no_share_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>BT 프리미엄 회원이 되어주세요!</span>
            <v-btn icon @click="no_more_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div class="word-break">프리미엄을 구독하시면 프로젝트를 다른 회원에게 공개할 수 있습니다.</div>
          </v-card-text>

          <v-card-actions>
            <v-btn class="primary" @click="toSignup" depressed block>
              프리미엄 구독하기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Multipane, MultipaneResizer } from 'vue-multipane'

import AppDrawer from './Drawer.vue'
import AppProjectNote from './Note.vue'
import { coloring } from '../../../custom/fn_color'

export default {
  metaInfo() {
    return {
      title: "Project"
    }
  },

  components: {
    AppDrawer,
    AppProjectNote,
    Multipane,
    MultipaneResizer,
  },

  data() {
    return {
      busy: false,

      drawer_open: 1,
      draggable: true,
      fixed_pane: false,
      left_margin_width: window.innerWidth - 400,
      pending_fab: false,

      mode: 1,
      view_tree: true,

      update_project_visible: false,
      share_project_visible: false,
      menu_bar_visible: false,
      is_inactive: false,
      activate_dialog: false,
      no_share_dialog: false,

      tree: {
        dir: 'horizontal',
        first: 0,
        second: 1
      }
    }
  },

  computed: {
    ...mapGetters({
      project_info: 'project/project_info',
      projects: 'project/projects',
      proj_docs: 'project/documents',
      add_documents_visible: 'modal/add_documents_visible',
      import_files_visible: 'modal/import_files_visible',
      expired: 'auth/is_expired',
      comments: 'comments/comments',
    }),

    proj_id() {
      return parseInt(this.$route.params.id)
    },

    proj_keys() {
      return this.proj_docs.map(v => v.key)
    },

    query() {
      return this.$route.query
    },

    doc() {
      return this.$route.query.doc
    },

    vid() {
      return this.$route.query.vid
    },

    query_comments() {
      return this.$route.query.comments
    },

    comments_on() {
      return this.$route.query.comments == 'true' ? true : false
    },

    activate_possible() {
      return !!this.projects ?
        (3 - this.projects.filter(v => v.mode!=9 && v.status<10).length) > 0 : false
    },

  },

  watch: {

    proj_id: {
      async handler() {
        await this.getProject()
      },
      immediate: true,
    },

    query: {
      handler(val) {
        if (this.drawer_open==0&&!!val) {
          this.drawer_open = 1
        }
      }
    },

    query_comments: {
      handler(val) {
        if (val!='true' && !!val) {
          this.$router.replace({ name: 'project' })
        }
      },
      immediate: true
    },

    project_info: {
      handler(val) {
        if (!val.num_docs) {
          this.drawer_open = 1
        } else if (val.list_mode != this.drawer_open) {
          this.drawer_open = !!val.list_mode ? 1 : 0
        }
        this.mode = val.mode >= 10 ? 11 : 1
        if (this.mode != val.mode) { this.setMode() }
        this.is_inactive = (this.project_info.status >= 10)
        this.getComments()
      },
    },

    drawer_open: {
      async handler(val) {
        this.calcDrawer()
        try {
          this.pending_fab = true
          await this.$store.dispatch('project/updateProjectListMode', {
            proj_id: parseInt(this.$route.params.id),
            list_mode: val
          })
        } finally {
          this.pending_fab = false
        }
      },
    },
  },

  created() {
    this.resize()
    window.addEventListener("resize", this.resize)
    this.$store.commit("tree/setTreeMode", {
      mode: 'project', 
      base: parseInt(this.$route.params.id)
    })
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  methods: {
    coloring,

    ...mapMutations({
      showAddDocumentsModal: 'modal/showAddDocuments',
      hideAddDocumentsModal: 'modal/hideAddDocuments',
      hideImportFilesModal: 'modal/hideImportFiles',
      showExpiredModal: 'modal/showExpired',
    }),

    resize() {
      this.calcDrawer()
    },

    onResize({ width, height }) {
      this.left_margin_width = width
    },

    calcDrawer() {
      if (!!this.drawer_open) {
        if (window.innerWidth <= 800) {
          this.fixed_pane = true
          this.draggable = false
        } else {
          this.fixed_pane = false
          this.draggable = true
        }
      } else {
        this.draggable =  false
        this.fixed_pane = false
      }
    },

    async getProject() {
      this.busy = true
      let vm = this
      // TODO. Error handling
      try {
        await this.$store.dispatch('project/getProjects')
      } finally {
        let projs = this.$store.getters['project/projects']
        let doc_clip_id = projs.filter(v => v.mode == 9)[0].proj_id
        // console.log('clip_id', doc_clip_id, vm.$route.params.id)
        let proj_ids = projs.map(v => v.proj_id)
        if (!projs.length || !proj_ids.includes(parseInt(vm.$route.params.id))) {
          this.$router.replace({ name: 'lab' })
        } else if (parseInt(vm.$route.params.id) == doc_clip_id) {
          this.$router.replace({ name: 'document-clip' })
        } else {
          await this.$store.dispatch('project/getProject', {
            proj_id: parseInt(this.$route.params.id)
          })
        }
        this.busy = false
      }
    },
    
    async getComments(){
      this.$store.dispatch('comments/getComments', this.proj_id)
    },

    updateProject() {
      this.update_project_visible = true
    },

    shareProject() {
      if (this.expired) {
        this.no_share_dialog = true
      } else {
        this.share_project_visible = true
      }
    },

    reloadTree() {
      this.$refs.tree.init_unit()
    },

    async setMode() {
      await this.$store.dispatch('project/updateProject', {
        proj_id: this.project_info.proj_id,
        mode: this.mode
      })
    },

    showAddDocuments() {
      if (this.is_inactive) {
        this.showExpiredModal()
      } else {
        this.showAddDocumentsModal()
        this.$analytics.logEvent('click', { name: 'project_btn_openAddDocuments' })
      }
    },

    async addDocumentToProject() {
      if (this.is_inactive) {
        this.showExpiredModal()
      } else {
        try {
          await this.$store.dispatch('project/addDocumentsToProject', {
            proj_id: this.proj_id,
            documents: [ this.doc ]
          })
        } 
        finally {
          this.$analytics.logEvent('click', { name: 'projectDrawerDoc_btn_addDocument' })
        }
      }
    },

    async removeDocumentFromProject() {
      if (this.is_inactive) {
        this.showExpiredModal()
      } else {
        try {
          await this.$store.dispatch('project/removeDocumentsFromProject', {
            proj_id: this.proj_id,
            documents: [ this.doc ],
          })
        } finally {
          this.$analytics.logEvent('click', { name: 'projectDrawerDoc_btn_removeDocument' })
        }
      }
    },

    async activateProject() {
      this.activate_dialog = false
      try {
        await this.$store.dispatch('project/updateStatus', {
          proj_id: this.proj_id,
          status: this.project_info.status - 10
        })
        await this.$store.dispatch('project/getProject', {
          proj_id: this.proj_id
        })
      } finally {
        this.is_inactive = (this.$store.getters['project/project_info'].status >= 10)
      }
    },

    toSignup() {
      this.activate_dialog = false
      this.$router.push({ name: 'signup' })
    },
  },
}
</script>

<style scoped>

  /* Layout */
  #wrap-project {
    background-color: #ffffff;
    height: 100vh;
    overflow-y: hidden;
  }

  #content-wrap {
    display: flex;
    flex-direction: column;
  }

  #content {
    position: relative;
    min-width: 400px;
  }

  #tree {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select:none;
    user-select:none;
    -o-user-select:none;
  }

  #fab-new-doc {
    position: absolute;
    right: 65px;
    top: 10px;
    z-index: 9;
  }

  #fab-drawer {
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 9;
  }

  #fab-note {
    position: absolute;
    left: 20px;
    bottom: 20px;
    z-index: 9;
  }

  #content-left {
    height: calc(100vh - 60px);
    width: 100vw;
    position: relative;
    z-index: 1;
  }

  #pane-wrap {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 100vw;
    visibility: hidden;
    align-items: stretch;
  }

  #pane-left {
    width: calc(100vw - 400px);
    min-width: 200px;
  }

  .pane-left-removed, .pane-right-removed {
    width: 0px !important;
    min-width: 0px !important;
  }

  .pane-left-fixed, .pane-right-fixed {
    width: 100vw !important;
  }

  .multipane-resizer {
    width: 15px !important;
    visibility: visible !important;
    height: 100vh !important;
  }

  #pane-right {
    visibility: visible;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
    height: calc(100vh - 60px);
    background-color: #ffffff;
    flex-grow: 1;
    width: 400px;
    overflow-y: auto;
    transition: right .5s cubic-bezier(0.820, 0.085, 0.395, 0.895);
  }

  /* Left pane - Header */

  #header-project {
    background-color: #ffffff;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #dde2e5 solid 1px;
    z-index: 9;
    min-width: 400px;
  }

  #project-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
  }

  #btn-menu-wrap {
    width: 70px;
    height: 100%;
  }
  
  #btn-menu {
    height: 100%;
    margin: 0 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ff5193;
  }

  #bt-subtitle{
    font-family: "Bree Serif", Roboto, 'Noto Sans', 'Noto Sans KR', "Apple SD Gothic Neo", sans-serif;
    font-size: 16pt;
    margin-left: 8px;
    transform: translateY(-2px);
  }

  #btn-more {
    margin-left: 8px;
  }

  #btn-pane {
    margin-right: 8px;
  }

  #btn-account {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 20px;
  }

  #comment-btn {
    margin-right: 8px;
  }

  .tree-tool {
    position: absolute;
    z-index: 100;
    top: 12px;
    left: 12px;
    cursor: pointer;
  }

  .card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/project/Layout.vue